export  default {
    getMenu(state) {
        return state.menu;
    },
    getMenuItems(state) {
        console.log("GET MENU ITEMS", state.menuItems);  //this is raw menu items, including hidden items
        return state.menuItems;  //this is raw menu items, including hidden items
    }
};